import { Types } from '@store/types';

const SystemPreferenceReducer = (state = false, action) => {
	switch (action.type) {
		case Types.SET_TOGGLE_PRICE:
			return action.payload;
		default:
			return state;
	}
};

export default SystemPreferenceReducer;
